export default __webpack_public_path__ + "static/media/bag8.77e33ca5.jfif";